import { OrganizationalRole } from '../../../../../utils/classes/graphql'
import { organizationalRolesKeysAndColumns } from '../helpers'
import {
  getDenseTableRowProps,
  TableType,
  TitledTable
} from '../../../../../components'

interface OrganizationalRolesProps {
  organizationalRoles?: OrganizationalRole[]
}

export const OrganizationalRoles = ({
  organizationalRoles
}: OrganizationalRolesProps) => {
  return (
    <TitledTable
      translationid="pages.ownInfoPage.assignments.organizationalRoles.label"
      tableProps={{
        cellProps: organizationalRolesKeysAndColumns,
        data: getDenseTableRowProps(organizationalRoles),
        type: TableType.Static
      }}
    />
  )
}
